import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getBrowserDetails } from '../utils/browser.util';

@Injectable()
export class ClientDetailsInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        //sdata: Buffer.from(JSON.stringify(getBrowserDetails())).toString('base64'),
      },
    });
    return next.handle(request);
  }
}
